import {EventSubscriber, HasEventName} from "@/modules/base/events";
import {inject, injectable} from "inversify";
import {CoachFactory} from "@/modules/training/services/SponsorFactory";
import {AfterCreateGameEvent} from "@/modules/base/events/AfterCreateGameEvent";

@injectable()
export class GameCreationEventSubscriber implements EventSubscriber {
  constructor(
    @inject(CoachFactory) private coachFactory: CoachFactory,
  ) {
  }

  priority(): number {
    return 0;
  }

  init(): { event: HasEventName; callback: (event: any) => void }[] {
    return [
      {event: AfterCreateGameEvent, callback: this.onAfterCreateGameEvent},
    ];
  }

  async onAfterCreateGameEvent(event: AfterCreateGameEvent): Promise<void> {
  }
}